/** Unified GoSnel login hub. */
export const AUTH_HUB_URL = (
  import.meta.env.VITE_AUTH_HUB_URL || 'https://auth.gosnel.com'
).replace(/\/$/, '');

export function goToAuthHub() {
  if (typeof window === 'undefined') return;
  window.location.assign(AUTH_HUB_URL);
}
